import { useFileDialog } from "@vueuse/core";

export const useFileSelect = () => {
  const dialog = useFileDialog({
    accept: "image/*,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp,.pdf,.rtf,.epub,.mobi,.md,.html,.htm,.xml,.jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.svg,.webp,.csv"
  });

  const select = (): Promise<FileList | null> => {
    return new Promise<FileList | null>((resolve) => {
      dialog.reset();
      dialog.open();
      // @ts-ignore
      const fn = dialog.onChange((list: FileList) => {
        if (!list || !list.length) {
          fn.off();
          return resolve(null);
        }
        fn.off();
        resolve(list);
      });
    })
  }

  return {select};
}
